function initializeOutletCarousel(section) {
  if (section.dataset.initialized === 'true') return;

  const swiperElement = section.querySelector('[data-outlet-carousel-swiper]');
  if (!(swiperElement instanceof HTMLElement) || typeof window.Swiper !== 'function') return;

  section.dataset.initialized = 'true';
  section.outletCarouselSwiper = new window.Swiper(swiperElement, {
    slidesPerView: 1.4,
    spaceBetween: 20,
    loop: section.dataset.loop === 'true',
    watchOverflow: true,
    keyboard: { enabled: true, onlyInViewport: true },
    a11y: { enabled: true },
    navigation: {
      nextEl: section.querySelector('[data-outlet-carousel-next]'),
      prevEl: section.querySelector('[data-outlet-carousel-prev]'),
    },
    breakpoints: {
      750: { slidesPerView: 3 },
      994: { slidesPerView: 3.6 },
    },
    observer: true,
    observeParents: true,
  });
}

function initializeOutletCarousels(scope = document) {
  scope.querySelectorAll('[data-outlet-carousel]').forEach((section) => {
    if (section instanceof HTMLElement) initializeOutletCarousel(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeOutletCarousels(), { once: true });
} else {
  initializeOutletCarousels();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) initializeOutletCarousels(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target instanceof Element ? event.target.querySelector('[data-outlet-carousel]') : null;
  section?.outletCarouselSwiper?.destroy(true, true);
});
